import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Snackbar,
  Alert,
  TextField,
  Typography,
} from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const languages = [
  { value: "en", label: "English" },

  // Coming after launch / localization is ready:
  // { value: "es", label: "Spanish" },
  // { value: "ru", label: "Russian" },
  // { value: "uz", label: "Uzbek" },
  // { value: "sr", label: "Serbian" },
  // { value: "tg", label: "Tajik" },
  // { value: "fa", label: "Farsi" },
  // { value: "lt", label: "Lithuanian" },
  // { value: "fr", label: "French" },
  // { value: "de", label: "German" },
  // { value: "zh", label: "Chinese" },
  // { value: "ar", label: "Arabic" },
  // { value: "pt", label: "Portuguese" },
  // { value: "it", label: "Italian" },
];
const timeZones = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Anchorage",
  "Pacific/Honolulu",
];

const LanguageAndLocalization = () => {
  const [form, setForm] = useState({
    language: "en",
    timeZone: "America/Denver",
    units: "imperial",
  });

  const [saved, setSaved] = useState(false);

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSave = () => {
    localStorage.setItem("hagglefreight_customer_locale", JSON.stringify(form));
    setSaved(true);
  };

  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 980, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, letterSpacing: "-0.02em", mb: 1 }}
        >
          Language & Localization
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          Manage your preferred language, time zone, and measurement units.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            p: { xs: 3, md: 4 },
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
  <TextField
    select
    fullWidth
    label="Language"
    name="language"
    value={form.language}
    onChange={handleChange}
  >
    {languages.map((language) => (
      <MenuItem key={language.value} value={language.value}>
        {language.label}
      </MenuItem>
    ))}
  </TextField>

  <Typography
    variant="caption"
    color="text.secondary"
    sx={{
      display: "block",
      mt: 1,
      ml: 1,
    }}
  >
   More languages coming soon: Russian, Spanish, Uzbek, 
   Turkish, Serbian, Ukrainian, Farsi, Lithuanian, and more.
  </Typography>
</Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                label="Time Zone"
                name="timeZone"
                value={form.timeZone}
                onChange={handleChange}
              >
                {timeZones.map((zone) => (
                  <MenuItem key={zone} value={zone}>
                    {zone}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Default Units"
                  name="units"
                  value={form.units}
                  onChange={handleChange}
                >
                <MenuItem value="imperial">Imperial (mi, lb)</MenuItem>
                <MenuItem value="metric">Metric (km, kg)</MenuItem>
                </TextField>

               <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                     display: "block",
                     mt: 1,
                     ml: 1,
                  }}
                >
                   Choose your preferred measurement format.
                </Typography>
             </Grid>
          </Grid>

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{ py: 1.3, px: 4, textTransform: "none", fontWeight: 700 }}
            >
              Save Settings
            </Button>
          </Box>
        </Paper>

        <Snackbar
          open={saved}
          autoHideDuration={3500}
          onClose={() => setSaved(false)}
        >
          <Alert
            severity="success"
            variant="filled"
            onClose={() => setSaved(false)}
          >
            Language and localization settings saved.
          </Alert>
        </Snackbar>
      </Box>
    </CustomerLayout>
  );
};

export default LanguageAndLocalization;
